/**
 * [SocketManager description]
 * @param {String} socketHost url of socket connection
 * @param {String} room       room to join
 */
import io from 'socket.io-client'

let SocketManager = function (socketHost, roomName, token, callback) {
  let sm = this
  let socket = io.connect(socketHost)

  sm.room = roomName || getParameterByName('room') || 'general' // TODO: change 'general'

  socket.on('connect', () => {
    console.log('SocketManager connected to ' + roomName + ' @ ' + socketHost)
    socket.emit('authentication', { token })
    socket.on('authenticated', () => {
      callback()
      socket.emit('loadMessages', sm.room) // ask for old messages and to join artist soundroom
    })
    socket.on('unauthorized', (err) => {
      sm.onError('There was an error with the authentication: ' + err.message) // TODO: don't use alert
      sm.close()
    })
    socket.on('newMessage', (a) => {
      sm.onMessage(a)
    })
    socket.on('loadMessages', (a) => {
      sm.onLoadMessages(a)
    })
    socket.on('roomInfo', (a) => {
      sm.onRoomInfo(a)
    })
    socket.on('userInfo', sm.onUserInfo)
    socket.on('disconnect', () => {
      sm.onDisconnect()
    })
    socket.on('reconnect', sm.onReconnect)
    socket.on('messageError', (a) => sm.onError(a))
  })

  /**
   * [messageConstructor description]
   * @param  {String} text [description]
   * @param  {User} from [description]
   * @return {Message}      [description]
   */
  var messageConstructor = (text, from) => {
    return { from, text, time: Date.now(), localId: Date.now() * Math.random() } // fix id generation
  }

  /**
   * [sendMessage description]
   * @param  {String} text [description]
   * @param  {User} from [description]
   */
  sm.sendMessage = (text, from) => {
    if (text.trim() === '') {
      return
    }
    var message = messageConstructor(text, from)
    sm.onMessageSending(message)
    socket.emit('newMessage', message) // From field doesn't matter because server knows who this is
  }

  sm.idle = () => {
    socket.emit('idleUser')
  }

  sm.online = () => {
    socket.emit('onlineUser')
  }

  sm.updateSettings = (settings) => {
    socket.emit('settingsUpdate', settings)
  }

  sm.onDisconnect = () => {
    console.log('disconnected :(') // switch to toast eventually instead
  }

  sm.onReconnect = () => {
    console.log('reconnected :)') // switch to toast eventually instead
    socket.emit('loadMessages', sm.room) // reload messages
  }

  // sm.loadMessages = () => {
  //   // socket.emit('loadMessages', sm.room)
  // }

  sm.close = () => {
    socket.close()
  }

  sm.onUserInfo = (user) => {
    // Override
  }

  sm.onRoomInfo = (room) => {
    // Override
  }

  sm.onMessageSending = (message) => {
    // Override
  }

  sm.onMessage = (message) => {
    // Override
  }

  sm.onLoadMessages = (message) => {
    // Override
  }

  sm.onError = () => {
    // Override
  }

  sm.moreMessages = (chunk) => {
    socket.emit('moreMessages', chunk)
  }

  return sm
}

// Helper functions
var getParameterByName = (name, url) => {
  if (!url) url = window.location.href
  name = name.replace(/[[]]/g, '\\$&')
  var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)')
  var results = regex.exec(url)
  if (!results) return null
  if (!results[2]) return ''
  return decodeURIComponent(results[2].replace(/\+/g, ' '))
}

export default SocketManager



// WEBPACK FOOTER //
// ./src/services/chat.js